export const enum DefaultToolbarItemOrder {
    FrameRate = 300,
    RefreshProperties = 200,
    Feedback = 100,
    CliStatus = 0,
}
